import { render, staticRenderFns } from "./groupMgr.vue?vue&type=template&id=2554f702&scoped=true"
import script from "./groupMgr.vue?vue&type=script&lang=js"
export * from "./groupMgr.vue?vue&type=script&lang=js"
import style0 from "./groupMgr.vue?vue&type=style&index=0&id=2554f702&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2554f702",
  null
  
)

export default component.exports